<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-expansion-panels multiple v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header>Designation</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- <designation-selection
                :show-dense="false"
                :show-select="true"
                v-model="selectedDesig"
                :key="componentKey"
              ></designation-selection> -->
              <v-data-table
                :items="selectedDesig"
                :headers="orgHeaders"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Department</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- <department-selection
                :show-dense="false"
                :show-select="true"
                v-model="selectedDep"
                :key="componentKey"
              ></department-selection> -->
              <v-data-table
                :items="selectedDep"
                :headers="orgHeaders"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Section</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- <section-selection
                :show-dense="false"
                :show-select="true"
                v-model="selectedSection"
                :key="componentKey"
              ></section-selection> -->
              <v-data-table
                :items="selectedSection"
                :headers="orgHeaders"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Movement Type</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- <movement-type-selection
                :show-dense="false"
                :show-select="true"
                v-model="selectedMT"
                :param="movementTypeParam"
                :key="componentKey"
              ></movement-type-selection> -->
              <v-data-table
                :items="selectedMT"
                :headers="orgHeaders"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>

      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.inCharge="{ item }">
          <v-btn @click.stop="viewInCharge(item)" text outlined>
            View
          </v-btn>
        </template>
        <!-- <template v-slot:item.actions="{ item }">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
          <v-btn
            @click.stop="addSub(item)"
            text
            outlined
            v-if="!item.subStepSequence"
            >Add sub</v-btn
          >
        </template>
        <template v-slot:item.inCharge="{ item }">
          <v-btn @click.stop="viewInCharge(item)" text outlined>
            View
          </v-btn>
        </template>
        <template v-slot:item.stepSequence="{ item }">
          <span v-if="!item.subStepSequence">{{ item.stepSequence }}</span>
        </template> -->
      </v-data-table>

      <v-row>
        <v-col>
          <v-btn color="success" @click.stop="approve" :loading="loading"
            >Approve</v-btn
          >&nbsp;
          <!-- <v-btn @click.stop="decline" :loading="loading">Decline</v-btn> -->
          <v-btn @click.stop="back">Back</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="viewDialog" width="600" persistent>
      <v-card>
        <v-card-title>
          <span>In Charge</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Employee Code
                  </th>
                  <th class="text-left">
                    Name
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in inCharge" :key="item.empCode">
                  <td>{{ item.empCode }}</td>
                  <td>{{ item.fullName }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click.stop="viewDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const DesignationSelection = () =>
  import(
    "@/views/setup/employment-info/employee-level/designation/NewSelection"
  );

const DepartmentSelection = () =>
  import(
    "@/views/setup/employment-info/organizational-level/department/NewSelection"
  );
const SectionSelection = () =>
  import(
    "@/views/setup/employment-info/organizational-level/section/NewSelection"
  );

const MovementTypeSelection = () =>
  import("@/views/setup/general/movement-type/Selection");
import { isNullOrUndefined } from "../../../validation/validation";
import { headers } from "./variable";
import isEmpty from "lodash/isEmpty";
export default {
  data: () => ({
    title: "Onboarding Plan Setup Approval",
    panel: [0],
    selectedDesig: [],
    selectedDep: [],
    selectedSection: [],
    selectedMT: [],
    movementTypeParam: "NHR,NHC,NHP,ROC",
    items: [],
    headers,
    loading: false,
    selectedIndex: -1,
    viewDialog: false,
    inCharge: [],
    inChargeHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false,
      },
    ],
    orgHeaders: [
      {
        text: "Code",
        value: "code",
        sortable: false,
      },
      {
        text: "Description",
        value: "desc",
        sortable: false,
      },
    ],
    componentKey: 0,
  }),
  components: {
    DesignationSelection,
    DepartmentSelection,
    SectionSelection,
    MovementTypeSelection,
  },
  methods: {
    getDetails(transNo) {
      this.$axios
        .get(`/api/onboarding/setup/approval/${transNo}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getOrgLevls(transNo) {
      this.$axios
        .get(`/api/onboarding/setup/approval/org/${transNo}`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            var mappedDes = data.designations.map((a) => {
              // return {
              //   desCode: a.desCode,
              //   desDesc: a.desDesc,
              // };
              return {
                code: a.desCode,
                desc: a.desDesc,
              };
            });
            this.selectedDesig = mappedDes;
            var mappedDep = data.departments.map((a) => {
              // return {
              //   depCode: a.departmentCode,
              //   depDesc: a.departmentDesc,
              // };
              return {
                code: a.departmentCode,
                desc: a.departmentDesc,
              };
            });
            this.selectedDep = mappedDep;

            var mappedSec = data.sections.map((a) => {
              // return {
              //   secCode: a.sectionCode,
              //   secDesc: a.sectionDesc,
              // };
              return {
                code: a.sectionCode,
                desc: a.sectionDesc,
              };
            });
            this.selectedSection = mappedSec;
            var mappedMT = data.movementTypes.map((a) => {
              // return {
              //   code: a.movementTypeCode,
              //   description: a.movementTypeDesc,
              // };
              return {
                code: a.movementTypeCode,
                desc: a.movementTypeDesc,
              };
            });
            this.selectedMT = mappedMT;
            this.componentKey += 1;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    approve() {
      this.submitApproval("APPROVED");
    },
    back() {
      this.$router.push(`/onboarding-plan-setup-app`);
    },
    submitApproval(status) {
      var param = {
        status,
        transNo: this.$route.params.transNo,
        order: this.$route.query.order,
      };
      this.loading = true;
      this.$axios
        .post(`/api/onboarding/setup/approval`, param)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.$router.push("/onboarding-plan-setup-app");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRefSeq(step, subStep, subStep2) {
      if (!isNullOrUndefined(subStep2)) {
        return `Checklist ${step} - Sub ${subStep}.${subStep2}`;
      } else if (!isNullOrUndefined(subStep)) {
        return `Checklist ${step} - Sub ${subStep}`;
      } else {
        return `Checklist ${step}`;
      }
    },
    viewInCharge(item) {
      this.selectedIndex = this.items.indexOf(item);
      this.inCharge = item.inCharge;
      this.viewDialog = true;
    },
  },
  created() {
    // this.selectedDesig = [{ desCode: "DES006", desDesc: "ACF Operator" }];
    var transNo = this.$route.params.transNo;
    this.getDetails(transNo);
    this.getOrgLevls(transNo);
  },
};
</script>
